import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/participants/:id(/:edit)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/ParticipantContainer',
      './modules/participant'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Participant = require('./containers/ParticipantContainer').default
      const actions = require('./modules/participant')
      const reducer = require('./modules/participant').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'participant', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.id, nextState.params.teamId, nextState.params.edit))

      /*  Return getComponent   */
      cb(null, Participant)

    /* Webpack named bundle   */
    }, 'participant')
  }
})




// WEBPACK FOOTER //
// ./src/routes/Participant/index.js